var _style, _defs, _defs2, _defs3, _path, _defs4, _defs5, _defs6, _path2, _defs7, _defs8, _defs9, _path3, _defs0, _defs1, _defs10, _path4, _defs11, _defs12, _defs13, _path5, _defs14, _defs15, _defs16, _path6, _defs17, _defs18, _defs19, _path7, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _path8, _defs27, _defs28, _defs29, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeometricNeuronBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 42.7",
    style: {
      enableBackground: "new 0 0 40 42.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000088816487659423603190000015743600597956391834_);}\r\n\t.st1{clip-path:url(#SVGID_00000027601724351398414880000017598973598499667132_);}\r\n\t.st2{clip-path:url(#SVGID_00000041982807489133286410000016364254101053474224_);}\r\n\t.st3{fill:#3090D8;}\r\n\t.st4{clip-path:url(#SVGID_00000050637764241651201190000001258984355657661579_);}\r\n\t.st5{clip-path:url(#SVGID_00000000195215323723112050000002572792287683262895_);}\r\n\t.st6{clip-path:url(#SVGID_00000140010567927435597700000013917229520393608866_);}\r\n\t.st7{clip-path:url(#SVGID_00000107584475349198118790000008322255592004027283_);}\r\n\t.st8{clip-path:url(#SVGID_00000112626841907661554610000010262688330518077605_);}\r\n\t.st9{clip-path:url(#SVGID_00000017479571708604862760000000022819745750567053_);}\r\n\t.st10{clip-path:url(#SVGID_00000128480036863662699850000006097852804947393187_);}\r\n\t.st11{clip-path:url(#SVGID_00000154394703946566382150000003576305624856053154_);}\r\n\t.st12{clip-path:url(#SVGID_00000064339614375176695830000007101090743450697344_);}\r\n\t.st13{clip-path:url(#SVGID_00000090989544353057211620000018003194860173687168_);}\r\n\t.st14{clip-path:url(#SVGID_00000163066022813432785180000015665779293237895862_);}\r\n\t.st15{clip-path:url(#SVGID_00000074443784949774842850000013498488241235985813_);}\r\n\t.st16{clip-path:url(#SVGID_00000036209845564543504110000015796003963977315731_);}\r\n\t.st17{clip-path:url(#SVGID_00000106139578961852994200000008440289411516997260_);}\r\n\t.st18{clip-path:url(#SVGID_00000115507005460793348050000014433255699976290465_);}\r\n\t.st19{clip-path:url(#SVGID_00000005963565341767694830000012287506732543748512_);}\r\n\t.st20{clip-path:url(#SVGID_00000119823733326550370510000007426398394892427922_);}\r\n\t.st21{clip-path:url(#SVGID_00000146497695526564534160000014416327365005671319_);}\r\n\t.st22{clip-path:url(#SVGID_00000020361164066444127030000007524809263551157691_);}\r\n\t.st23{clip-path:url(#SVGID_00000067206260058050145500000014563669973557780630_);}\r\n\t.st24{clip-path:url(#SVGID_00000041976476151231715370000015645079240463367611_);}\r\n\t.st25{clip-path:url(#SVGID_00000137829179387925469410000014621653137078487696_);}\r\n\t.st26{clip-path:url(#SVGID_00000110468930097314217830000014219905188418813111_);}\r\n\t.st27{clip-path:url(#SVGID_00000101791329859481559650000010804844525127963013_);}\r\n\t.st28{clip-path:url(#SVGID_00000080890888765440706530000012157844500117334685_);}\r\n\t.st29{clip-path:url(#SVGID_00000012432345277630376830000018113781280242427520_);}\r\n\t.st30{clip-path:url(#SVGID_00000091699237727867229680000004737776531193839490_);}\r\n\t.st31{clip-path:url(#SVGID_00000123438481915151650920000013059562551307841981_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036219674871413557400000007204268495227709095_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036219674871413557400000007204268495227709095_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058574096497393939250000008269796284751267206_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006691744307296968950000013193040596218057640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058574096497393939250000008269796284751267206_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006691744307296968950000013193040596218057640_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000157290841020695178030000007555160676513376156_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086653864410708667060000006790188637668131992_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157290841020695178030000007555160676513376156_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000086653864410708667060000006790188637668131992_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.5,14.5c-2.3,1.3-4.9,2-7.4,2c-2.9,0-5.7-0.9-8-2.6c-0.5-0.3-0.6-1-0.2-1.5c0.3-0.5,1-0.6,1.5-0.2 c1.9,1.4,4.3,2.2,6.7,2.2c3.6,0,7.4-1.7,9.8-4.4c1.5-1.7,3.2-4.5,2.7-8.4C21.5,1,22,0.5,22.5,0.4c0.6-0.1,1.1,0.4,1.2,0.9 c0.4,3.7-0.7,7.2-3.3,10C19.4,12.6,18,13.7,16.5,14.5z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000024702833206189309360000009574823147242580643_",
    x: 16,
    y: 25.3,
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152979929057002004980000008262220434694841496_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024702833206189309360000009574823147242580643_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152979929057002004980000008262220434694841496_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000072974950454689540910000013661405531531197110_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145744317433715617570000016441415154821053597_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072974950454689540910000013661405531531197110_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145744317433715617570000016441415154821053597_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119084798419570426770000011711688962718065310_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026876354806720897580000013512210850561933501_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119084798419570426770000011711688962718065310_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026876354806720897580000013512210850561933501_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.7,30.2c-0.4,0.2-0.8,0.2-1.2-0.1c-1.9-1.4-4.3-2.2-6.7-2.2c-3.6,0-7.4,1.7-9.8,4.4 c-1.5,1.7-3.2,4.5-2.7,8.4c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c-0.4-3.7,0.7-7.2,3.3-10 c2.8-3.2,7.2-5.1,11.4-5.2c2.9,0,5.7,0.9,8,2.6c0.5,0.3,0.6,1,0.2,1.5C38.9,30.1,38.8,30.2,38.7,30.2z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000121242852348559565280000009635035905234790039_",
    y: 25.3,
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162347512547029778960000012161769909505436316_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121242852348559565280000009635035905234790039_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000162347512547029778960000012161769909505436316_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000193195237961631880000006655755706445772938_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114075929777660313900000000946948228556863910_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000193195237961631880000006655755706445772938_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114075929777660313900000000946948228556863910_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176746022770895578860000010687974834275519914_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149355250647667159370000004786390435189245069_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176746022770895578860000010687974834275519914_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000149355250647667159370000004786390435189245069_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.5,42.2c-0.2,0.1-0.4,0.2-0.6,0.1c-0.6-0.1-1-0.6-0.9-1.2c0.3-2.4-0.2-4.8-1.5-6.9 c-1.8-3.1-5.2-5.5-8.8-6.3c-2.2-0.5-5.4-0.5-8.6,1.8C1.6,30,1,29.9,0.6,29.5C0.2,29,0.3,28.4,0.8,28 c3-2.2,6.6-2.9,10.3-2.2c4.1,0.9,8,3.7,10.2,7.3c1.5,2.5,2.1,5.4,1.7,8.2C23,41.7,22.8,42,22.5,42.2z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000104702522352588250130000011877496426633393307_",
    x: 16,
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085968369761823459450000000895989438418745252_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104702522352588250130000011877496426633393307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085968369761823459450000000895989438418745252_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000093154434493430782000000000165202204139442048_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181080033690663617110000007182486251612353197_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093154434493430782000000000165202204139442048_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181080033690663617110000007182486251612353197_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044869354475358960860000007401779844644404922_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036226270827226461420000004909205671874848652_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044869354475358960860000007401779844644404922_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036226270827226461420000004909205671874848652_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.6,15.7c-2.7,1.5-5.7,1.9-8.9,1.3c-4.2-0.9-8-3.7-10.2-7.3c-1.5-2.5-2.1-5.4-1.7-8.2 c0.1-0.6,0.6-1,1.2-0.9s1,0.6,0.9,1.2c-0.3,2.4,0.2,4.8,1.5,6.9c1.8,3.1,5.2,5.5,8.8,6.3c2.2,0.5,5.4,0.5,8.6-1.8 c0.5-0.3,1.1-0.2,1.5,0.2c0.3,0.5,0.2,1.1-0.2,1.5C38.5,15.1,38.1,15.4,37.6,15.7z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145055411796520632080000005428136579961916832_",
    x: 26.7,
    y: 8,
    width: 12,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096026639321355628290000003002269934905333410_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145055411796520632080000005428136579961916832_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096026639321355628290000003002269934905333410_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085240957223424532820000016161576142207083678_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144322865086282219760000003754788316734559657_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085240957223424532820000016161576142207083678_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000144322865086282219760000003754788316734559657_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000131359922788592816670000014909487655217173180_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152233642442881027330000012638461541244866721_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131359922788592816670000014909487655217173180_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152233642442881027330000012638461541244866721_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.4,34.5c-0.3,0.2-0.6,0.2-0.9,0c-3.4-1.5-5.8-4.2-7-7.8c-1.3-4-0.9-8.8,1.2-12.4 c1.4-2.5,3.7-4.5,6.3-5.6c0.5-0.2,1.2,0,1.4,0.6c0.2,0.5,0,1.2-0.6,1.4c-2.2,0.9-4.1,2.6-5.3,4.7 c-1.8,3.1-2.2,7.3-1.1,10.7c0.7,2.1,2.3,5,5.9,6.6c0.5,0.2,0.8,0.9,0.5,1.4C36.7,34.3,36.6,34.4,36.4,34.5z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000099627214530005956950000001057050029084180897_",
    x: 2.7,
    y: 8,
    width: 10.7,
    height: 26.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117672606399725186220000015947401978899381926_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099627214530005956950000001057050029084180897_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000117672606399725186220000015947401978899381926_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039121318988775725970000006536512723620207240_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127758539041319570700000015102196106308657589_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039121318988775725970000006536512723620207240_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127758539041319570700000015102196106308657589_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034800151373641154030000016813895745734214056_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018202884391282061590000013275195624591883148_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034800151373641154030000016813895745734214056_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018202884391282061590000013275195624591883148_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.6,33.5c-0.4,0.2-0.8,0.4-1.2,0.6c-0.5,0.2-1.2,0-1.4-0.6c-0.2-0.5,0-1.2,0.6-1.4 c2.2-0.9,4-2.6,5.2-4.7c1.8-3.1,2.2-7.2,1.1-10.7c-0.7-2.1-2.3-5-5.9-6.6C3.5,9.9,3.3,9.2,3.5,8.7s0.9-0.8,1.4-0.5 c3.4,1.5,5.8,4.2,7,7.8c1.3,4,0.8,8.8-1.2,12.4C9.5,30.5,7.7,32.3,5.6,33.5z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000066476425022088615080000008206079558600011423_",
    x: 14.7,
    y: 16,
    width: 10.7,
    height: 10.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005233927619740185480000008561756450319838900_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066476425022088615080000008206079558600011423_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005233927619740185480000008561756450319838900_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065068745825719209790000015870855984526396813_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150786138843071977840000012707678337556305826_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065068745825719209790000015870855984526396813_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000150786138843071977840000012707678337556305826_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000048466523565899573100000018387114931086109334_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041271429230059335990000012696360975582653600_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048466523565899573100000018387114931086109334_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000041271429230059335990000012696360975582653600_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.6,18.8c1.4,2.5,0.5,5.7-2,7.1s-5.7,0.5-7.1-2c-1.4-2.5-0.5-5.7,2-7.1S23.2,16.3,24.6,18.8z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060018508619734741820000007552820348393400713_",
    x: 16,
    y: 13.3,
    width: 12,
    height: 13.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034080787762093866900000006472027066703635378_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060018508619734741820000007552820348393400713_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034080787762093866900000006472027066703635378_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000081633926116833935390000018051973225389050001_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122693049233437576060000003128944094080560770_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081633926116833935390000018051973225389050001_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122693049233437576060000003128944094080560770_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031893314597241708880000010963258272525557639_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054955494531832492230000005479581304223924151_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031893314597241708880000010963258272525557639_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054955494531832492230000005479581304223924151_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 717, 399)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080174506091321917690000010580040000763299737_",
    x: -701,
    y: -385.7,
    width: 12,
    height: 13.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044860864541590728880000017109347995993788040_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080174506091321917690000010580040000763299737_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044860864541590728880000017109347995993788040_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018941498379237011220000014669264846974195086_",
    x: -700.2,
    y: -383,
    width: 8.5,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047031202787596507520000006228346887404473483_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018941498379237011220000014669264846974195086_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047031202787596507520000006228346887404473483_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036957601047241918610000004885214182558698124_",
    x: -718,
    y: -397.2,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 95.7033 -385.267)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047053154837044967930000013661178147506981813_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036957601047241918610000004885214182558698124_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000047053154837044967930000013661178147506981813_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147193171713667582960000002489099879661181887_",
    x: -718,
    y: -397.2,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 95.7033 -385.267)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173135281647390065610000016645583973975703727_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147193171713667582960000002489099879661181887_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173135281647390065610000016645583973975703727_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-692.4-380.2c1.4,2.5,0.5,5.7-2,7.1c-0.2,0.1-0.4,0.2-0.6,0.3c2.1-1.5,2.8-4.4,1.5-6.8 c-1.3-2.3-4.1-3.3-6.5-2.3c0.2-0.1,0.3-0.2,0.5-0.3C-697-383.6-693.8-382.7-692.4-380.2z"
  }))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000086664894104650268940000004340909507843335589_",
    x: 17.3,
    y: 18.7,
    width: 5.3,
    height: 5.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105385234493822821130000009640331625546989710_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000086664894104650268940000004340909507843335589_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105385234493822821130000009640331625546989710_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100380860947504448660000008428691458423457202_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170982572238410663340000006344632267107707054_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100380860947504448660000008428691458423457202_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170982572238410663340000006344632267107707054_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000011738431305876973680000008135878110787442355_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057138340060259290690000010557876929638343351_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011738431305876973680000008135878110787442355_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057138340060259290690000010557876929638343351_)"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.3,20.1c0.7,1.2,0.2,2.8-1,3.5s-2.8,0.2-3.5-1s-0.2-2.8,1-3.5S21.6,18.9,22.3,20.1z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometricNeuronBlue);
export default __webpack_public_path__ + "static/media/geometric-neuron-blue.c72074b70f98e864cc7291b04c489c70.svg";
export { ForwardRef as ReactComponent };